import { get } from "../services"

export const excelTransform = async (SERVER, folder, file) => {
  const excelData = await get(`${SERVER}/getData/${folder}/${file}`);
  return excelData;
}
